/** USD with real decimals (0.9, 1.5, 361.06) — trims trailing zeros only. */
export const formatUsd = (amount: number | null | undefined): string => {
  if (amount == null || !Number.isFinite(Number(amount))) return '-';
  const n = Number(amount);
  const body = Math.abs(n)
    .toFixed(6)
    .replace(/\.?0+$/, '');
  return `$${body}`;
};

export const formatSignedUsd = (amount: number | null | undefined): string => {
  if (amount == null || !Number.isFinite(Number(amount))) return '-';
  const n = Number(amount);
  if (n === 0) return '-';
  const body = Math.abs(n)
    .toFixed(6)
    .replace(/\.?0+$/, '');
  return `${n > 0 ? '+' : '-'}$${body}`;
};

/** Intl currency with up to 4 decimals (calendar / summaries). */
export const formatUsdIntl = (amount: number) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 4,
  }).format(amount);
